import { COMPANY_CONFIG } from "companyConfig";
import CardTemplate from "../card-template/CardTemplate";
import { formatPhone } from "utils/formatPhone";

const IllinoisNotice = () => {
    return (
        <CardTemplate title="" px="px-6 tablet:px-6" className="!min-h-[100px] tablet:!min-h-[100px]">
            <div className="flex flex-col gap-4 pt-6" id="illinois-notice">
                <h3 className="font-sans font-bold text-lg leading-7 text-base-content">
                    Important Disclosure for Illinois Residents
                </h3>
                <p className="text-base-content font-medium text-sm leading-5" style={{ fontFamily: "Open Sans" }}>
                    If you are over age 65 or reside in a nursing home, please take time to carefully consider this offer. We
                    encourage you to review your current insurance coverage, consult with a trusted advisor such as a family
                    member or financial professional, and wait at least 48 hours before making any decision. If you have
                    questions, call{" "}
                    <a className="font-bold" href={`tel:${COMPANY_CONFIG.illinoisNumber}`}>
                        {formatPhone(COMPANY_CONFIG.illinoisNumber)}
                    </a>
                    .
                </p>
            </div>
        </CardTemplate>
    );
};

export default IllinoisNotice;
